
import Geometry from 'ol/geom/Geometry';
import Feature from 'ol/Feature';
import { WGisFeatureInfo, WGisFeatureInterface } from './wgis.utils';



export class WGisFeature extends Feature implements WGisFeatureInterface {
  private info: WGisFeatureInfo;
  constructor(optGeometryOrProperties?: Geometry | { [key: string]: any }) {
    super(optGeometryOrProperties);
    this.info = {
      layerId: null,
      engineName: null,
      layerName: null,
      layerkey: null,
      className: null,
      featId: null
    };
  }
  getWgisId(): string {
    return '' + this.info.className + ':::' + this.getProperties()[this.info.layerkey];
  }

  getWgisInfo(): WGisFeatureInfo {
    return this.info;
  }
  setWgisInfo(info: WGisFeatureInfo): void {
    this.info.layerId = info.layerId ? info.layerId : this.info.layerId;
    this.info.engineName = info.engineName ? info.engineName : this.info.engineName;
    this.info.layerName = info.layerName ? info.layerName : this.info.layerName;
    this.info.layerkey = info.layerkey ? info.layerkey : this.info.layerkey;
    this.info.className = info.className ? info.className : this.info.className;
    this.info.featId = info.featId ? info.featId : this.info.featId;
    this.setId(this.getWgisId());
  }

}